<template>
    <div>
         <client-note-form :getClientNoteList="getClientNoteList" ref="clientNoteFormModal"></client-note-form>
        <!-- table -->
      <vue-good-table
      enabled:false 
      id="clientNoteTable"
      ref="clientNoteTable" 
      :columns="columns" 
      :rows="rows"
      styleClass="vgt-table condensed tableSize" 
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }" 
        theme="my-theme">
        <div slot="emptystate">
          {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
          <span v-if="props.column.field === 'noteType'" class="text-nowrap">
            {{ $t('clientNote.note_type') }}
          </span>
          <span v-else-if="props.column.field === 'note'" class="text-nowrap">
            {{ $t('clientNote.note') }}
          </span>
          <span v-else-if="props.column.field === 'process'" class="text-nowrap"></span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
          <!-- Column: Process -->
          <span v-if="props.column.field === 'note'">
            <div v-b-tooltip.hover="{ title: props.row.note, customClass: 'wh-tooltip' }" class="wh-clamp-2">{{ props.row.note }}</div>
          </span>
          <span v-else-if="props.column.field === 'process'">
            <list-actions-dropdown :actions="[
              { icon: 'EditIcon', label: $t('others.edit'), handler: () => getInfo(props.row.id) }
            ]" />
          </span>
        </template>
      </vue-good-table>  
    </div>
</template>

<script>
  export default {
    props: {
      clientId: Number
    },
    data() {
      return {
        pageLength: 10,
        dir: false,
        columns: [
          {
            label: this.$t('clientNote.note_type'),
            field: `noteType`,
          },
          {
            label: this.$t('clientNote.note'),
            field: `note`,
          },
          {
            label: '',
            field: 'process',
            width: '10em',
            sortable: false
          },
        ],
        rows: [],
        searchTerm: '',
      }
    },
    mounted() {
      this.getClientNoteList()
    },
    methods: {
      async deleted(data) {
        data = { id: data.id }
        const controller = { name: 'ClientNote' }
        const payload = { data: data, controller: controller }
        this.$DeleteConfirm().then(result => {
          if (result.value) {
            this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
              if (response.data.resultStatus == true) {
                this.$DeleteAlert()
                this.getClientNoteList()
              } else {
                this.$WarningAlert(response.data.resultMessage)
                this.getClientNoteList()
              }
            })
          }
        })
      },
      async getInfo(id) {
        this.$refs.clientNoteFormModal.showInfo(id, this.clientId)
      },
      getClientNoteList() {
        this.rows = []
        const data = { id: this.clientId }
        const controller = { name: 'ClientNote', actionName:'GetClientNoteListByClientId' }
        const payload = { data: data, controller: controller }
        this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
          if (response.data.resultStatus == true) {
                response.data.clientNoteList.forEach(element => {
              this.rows.push(element)
            })
            
          }
          else {
            this.$WarningAlert(response.data.resultMessage)
          }
        }
        )
      },
    },
  }
  </script>
  <style lang="scss" >
    .tableSize {
      font-size: 13px!important;
      border-collapse: collapse;
      width: 100%;
      max-width: 100%;
      table-layout: auto;
  }
  </style>
  